import { useSelector } from 'react-redux';

import GuestHeader from './GuestHeader';
import UserHeader from './UserHeader';

const AppHeader = (props) => {
  const { children, loading, landing, subheader, hideSearch, pending } = props;

  const isloggedIn = useSelector((state) => state.authorization.isloggedIn);
  const Header = isloggedIn ? UserHeader : GuestHeader;

  return (
    <Header
      landing={landing}
      loading={loading}
      subheader={subheader}
      hideSearch={hideSearch}
      pending={pending}
    >
      {children}
    </Header>
  );
};

export default AppHeader;
